import TasksStatusesLookup from "../../model2/project/inheritance/task-statuses";
import Task from "../../model2/task/task";
import TaskWorkflow, {WorkflowType} from "../../model2/status/task-workflow";
import {TaskTypeSettingsVersion} from "../../model2/task-type/task-type-settings/@const";

type projectAndType = {
    projectId?  : ID
    taskTypeId? : ID
}

// const debug = "TaskStatusManager"
const debug = false

export default class TaskStatusManager {


    static getWorkflow(task: Task, options?:any):TaskWorkflow {

        // const { idOnly, exportToOptions, orderBySystemStatus } = options;
        const workflow : TaskWorkflow = new TaskWorkflow()

        if (!task || !task.projectId) {
            console.error("ERROR #98472xxx - missing task / params")
        }

        if (!task.taskTypeId) {
            console.error("ERROR #98472zzz - missing task type")
        }

        // Two options - ovveriden by project or from task type
        let statuses : any[]  // we'll put result here

        // try get form project
        const taskStatusesLookup = new TasksStatusesLookup(task.projectId)
        const statusesForProject : ID[] = taskStatusesLookup.getForTask()

        if (statusesForProject && statusesForProject.length>0) {

            debug && console.log(debug, "init from redefined project statuses")

            workflow.resetFromIds(statusesForProject)
            workflow.type = WorkflowType.TASK_FROM_PROJECT
            workflow.fromProjectId  = taskStatusesLookup.projectId

        } else {
            const taskType = gd.session.taskTypes.get(task.taskTypeId);
            const statuses = taskType.settings.version === TaskTypeSettingsVersion.V1 ? taskType.statuses.sortBySystemStatus() : taskType.statuses
            const taskTypeStatuses = _.map(statuses.models, (taskStatus:any) => taskStatus.status)
            workflow.resetFromConfig(taskTypeStatuses)
            workflow.type = WorkflowType.TASK_FROM_TASK_TYPE
        }

        workflow.applyACL(task)

        return workflow

    }



    static getProjectStatusesOverride(projectId:ID) {
        const project = gd.session.projects.get(projectId);
        const projectStatusesOverridden = project && project.taskStatusesOverride && project.taskStatusesOverride.length > 0;

        // get parent project with overridden statuses
        let inheritedOverriddenStatusesProjectId : any = null;
        const parentProjects = gd.tree.findProjectParents(gd.tree.getProject(projectId)).map((p:any) => p.id).reverse();
        parentProjects.map((pId:ID) => {
            if (!!inheritedOverriddenStatusesProjectId) return;

            const project = gd.session.projects.get(pId);
            if (project && project.taskStatusesOverride && project.taskStatusesOverride.length > 0) inheritedOverriddenStatusesProjectId = project.id;
        });

        return {
            overridden:                             projectStatusesOverridden || !!inheritedOverriddenStatusesProjectId,
            inheritedFromProjectId:                 !projectStatusesOverridden ? inheritedOverriddenStatusesProjectId : null,
            inheritedOverriddenStatusesProjectId:   inheritedOverriddenStatusesProjectId
        }
    }

    // static getDefaultTaskStatuses(projectId:ID) {
    //     const project = gd.session.projects.get(projectId);
    //     const { statuses } = gd.session.taskTypes.filterByCompany(project.companyId).models[0];
    //     return project && project.taskStatusesOverride && project.taskStatusesOverride.length > 0 ?
    //         project.taskStatusesOverride : statuses.map((s:any)=>s.status.id);
    // }

    static getTaskStatuses(params: projectAndType, options:any = {
        idOnly: false,
        exportToOptions: false,
        orderBySystemStatus: false
    }) {

        const projectId = params.projectId
        const taskTypeId = params.taskTypeId

        const { idOnly, exportToOptions, orderBySystemStatus } = options;
        let res;
        if (projectId) {
            res = new TasksStatusesLookup(projectId).getForTask();
        }

        if ((!res || res.length === 0) && taskTypeId) {
            res = gd.session.taskTypes.get(taskTypeId)?.statuses?.models.map((s:any)=>s.status.id);
        }

        if (!res) res = [];

        if (orderBySystemStatus) res = _.orderBy(res, id=>gd.session.statuses.get(id).systemStatus, 'asc');

        if (exportToOptions) {
            res = res.map((sId:ID)=>{
                const status = gd.session.statuses.get(sId);
                return {
                    value:          status.id,
                    systemStatus:   status.systemStatus,
                    label:          status.name,
                    color:          status.color
                }
            });
        } else if (!idOnly) {
            res = res.map((sId:ID)=>gd.session.statuses.get(sId));
        }

        return res;
    }

    static getTaskStatuses2(projectId:ID, options = {
        idOnly: false,
        exportToOptions: false,
        orderBySystemStatus: false
    }) {
        let statuses:any, source:any;
        if (projectId) {
            const parentProjects = gd.tree.findProjectParents(gd.tree.getProject(projectId)).map((p:any)=>p.id).concat([projectId]).reverse();
            parentProjects.map((pId:ID)=>{
                if (statuses) return;

                const project = gd.session.projects.get(pId);
                if (project && project.taskStatusesOverride && project.taskStatusesOverride.length > 0) {
                    statuses = project.taskStatusesOverride;

                    if (projectId === project.id)
                        source = {
                            type: 'custom',
                        }
                    else
                        source = {
                            type: 'inherited',
                            inheritedFromProjectId: project.id
                        }
                }
            });

            if (!statuses) {
                const project = gd.session.projects.get(projectId);
                if (project) {
                    const templateId = project.localTemplateId ? project.localTemplateId : project.sharedTemplateId;
                    const template = gd.session.projects.get(templateId);

                    if (template) {
                        statuses = template.taskStatusesOverride ? template.taskStatusesOverride : [];
                        source = {
                            type: 'inherited',
                            inheritedFromProjectId: template.id
                        }
                    }
                    else {
                        // this warning tormozil all statusss pochemu to
                        // console.warn("ProjectStatusManager getProjectStatuses:", project.name, "no localTemplateId or sharedTemplateId set");
                    }
                }
            }
        }

        if (!statuses) statuses = [];

        if (options.orderBySystemStatus) statuses = _.orderBy(statuses, id=>gd.session.statuses.get(id).systemStatus, 'asc');

        if (options.exportToOptions) {
            statuses = statuses.map((sId:ID)=>{
                const status = gd.session.statuses.get(sId);
                return {
                    value:          status.id,
                    systemStatus:   status.systemStatus,
                    label:          status.name,
                    color:          status.color
                }
            });
        } else if (!options.idOnly) {
            statuses = statuses.map((sId:ID)=>gd.session.statuses.get(sId));
        }

        return {
            statuses,
            source
        };
    }
}
